import {
  ListAvailabilityTimeSlotsRequest,
  ListAvailabilityTimeSlotsResponse,
} from '@wix/ambassador-bookings-availability-v2-time-slot/types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { CalendarState } from '../../components/BookingCalendar/controller';
import { listAvailabilityTimeSlots as listAvailabilityTimeSlotHttpRequest } from '@wix/ambassador-bookings-availability-v2-time-slot/http';

export const listAvailabilityTimeSlots = async (
  listAvailabilityTimeSlotRequest: ListAvailabilityTimeSlotsRequest,
  flowAPI: ControllerFlowAPI,
  state: CalendarState,
): Promise<ListAvailabilityTimeSlotsResponse> => {
  try {
    // void panoramaQueryAvailabilityInteractionStart({
    //   flowAPI,
    //   state,
    //   request: listEventTimeSlotsRequest,
    // });
    const response = (
      await flowAPI.httpClient.request(
        listAvailabilityTimeSlotHttpRequest(listAvailabilityTimeSlotRequest),
      )
    ).data;

    // void panoramaQueryAvailabilityInteractionEnd({
    //   flowAPI,
    //   response,
    // });

    return response;
  } catch (e) {
    // void panoramaQueryAvailabilityInteractionEnd({
    //   flowAPI,
    //   error: e as string,
    // });
    throw e;
  }
};
